'use strict';

/**
 * View for rrendering an image in the list
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/components/asset-upload-list-item.hbs');

var AssetUploadListItemView = ColidoItemView.extend({
    template: template,

    tagName: 'li',

    ui: {
        'removeAsset': '[data-action="remove-asset"]',
    },

    events: {
        'click @ui.removeAsset': 'removeAsset',
    },

    modelEvents: {
        'change request sync': 'render',
    },

    /**
     * Event for handling remove
     * @param {object} event The event object
     * @return {void}
     */
    removeAsset: function(event) {
        event.preventDefault();

        this.model.collection.remove(this.model);
    },
});

module.exports = AssetUploadListItemView;